// TopPlayers.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl, topPlayersApi } from '../api/api'; // adjust path if needed
import PlayerDetails from './PlayerDetails';
import Button from './Button';
import { FaStar } from "react-icons/fa6";
const TopPlayers = () => {
  const [players, setPlayers] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        const response = await axios.get(`${baseUrl}${topPlayersApi}`);
        const sorted = response.data.sort((a, b) => {
          const ratingA = parseFloat(a.statistics[0]?.games?.rating || 0);
          const ratingB = parseFloat(b.statistics[0]?.games?.rating || 0);
          return ratingB - ratingA;
        });
        setPlayers(sorted);
      } catch (err) {
        console.error("Error fetching players", err);
      }
    };

    fetchPlayers();
  }, []);

  if (selectedPlayer) {
    return <PlayerDetails player={selectedPlayer} onBack={() => setSelectedPlayer(null)} />;
  }

  return (
<div className="p-4">
  <div className="grid gap-4 w-full max-w-xl mx-auto">
    {players.map((item, index) => (
      <div
        key={item.player.id}
        className="bg-gray-50 p-4 rounded-md border-2 border-transparent hover:border-red-500 hover:shadow-[0_4px_20px_rgba(239,68,68,0.5)] transition-all duration-300"
      >
        <div className="flex items-center gap-4">
          <img
            src={item.player.photo}
            alt={item.player.name}
            className="w-20 h-20 object-cover rounded-full shrink-0"
          />
          <div className="flex flex-col">
            <div className="font-bold text-lg sm:text-xl">
              {index + 1}. {item.player.name}
              <br/> <span className="text-sm sm:text-base mt-1 font-semibold text-gray-600">
               <FaStar color="orange" /> Rating: {item.statistics[0]?.games?.rating || "N/A"}
               </span>
               <span className="mt-4 flex justify-start">
                <Button onClick={() => setSelectedPlayer(item)} />
                  </span>
            </div>
        
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  );
};

export default TopPlayers;
